<template lang="pug">
.ant-forest-success(v-show="!preparing||showNew")
  .banner(:class="{ 'mode-b': modeB }")
    img.success-icon(
      v-if="modeB",
      alt="ok",
      src="https://m.hellobike.com/resource/AppPlatformH5/ant-forest/bdzxfVRlyuEW0CcOLeBVJ.png"
    )
    .title(v-else)
      template(v-if="!showNew")
        .flex-mid APP骑哈啰单车、助力车
        .flex-mid 也可以获得蚂蚁森林绿色能量啦
      template(v-else)
        .flex-mid APP骑行也可以获得蚂蚁森林绿色能量啦
  .part-1(v-if="modeB")
    .top 开启成功
    .bottom.flex-mid 能量发放至支付宝账号：{{ account }}
  template(v-if="!showNew")
    .part-2
      .title 获得能量的条件
      .conditions
        .condition-item.flex-mid
          img.condition-icon(
            src="https://m.hellobike.com/resource/AppPlatformH5/ant-forest/_6nadD7-zkMtcUPRQZwVr.png"
          )
          .condition-content 2020.11.5之后用
          .condition-content 支付宝购卡或付车费
        .condition-item.flex-mid
          img.condition-icon(
            src="https://m.hellobike.com/resource/AppPlatformH5/ant-forest/Mq-XZVvrrFV3OC2f2sKDf.png"
          )
          .condition-content 骑行单车或
          .condition-content 助力车
        .condition-item.flex-mid
          img.condition-icon(
            src="https://m.hellobike.com/resource/AppPlatformH5/ant-forest/VRDrwJj1AGbVxkGHrWitS.png"
          )
          .condition-content 单次骑行
          .condition-content 3分钟以上
    .part-3
      .title 我能获得多少能量
      .rules
        .rule
          .rule-title 单次骑行最高获得能量
          .rule-content
            span 1.8g/分钟 x 单次骑行上限30分钟 = 54g
        .rule
          .rule-title 单日骑行最高获得能量
          .rule-content
            span 1.8g/分钟 x 单日累计上限88分钟 = 159g
            span.gray (向上取整)
  template(v-else)
    Condition
  .close.flex-mid(v-if="!success && !plain")
    img.close-icon(
      src="https://m.hellobike.com/resource/AppPlatformH5/ant-forest/cTPmqtlSGwZxXsgrhqNRf.svg"
    )
    span.text(@click="openDialog") 关闭蚂蚁森林能量
  .hint
    .row 注：
    .row
      span · 需要确认您已开通支付宝蚂蚁森林账号，才能在使用哈啰APP骑行后获得绿色能量。
      span.go(@click="goForest") 点击查看蚂蚁森林开通状态。
    .row · 蚂蚁森林能量需至支付宝App内领取。
    .row(@click="goRule") · 查看能量获得规则 &gt;
  Dialog(:show="dialog", @cancel="dialog = false", @ok="close")
  CommonDialog(v-model="warnDialog")
    .warn-dialog
      img.warn-logo(
        src="https://m.hellobike.com/resource/AppPlatformH5/ant-forest/SA9tCtz8l53J4vjJU1aKv.png"
      )
      .title 骑行卡用户提醒
      .content 若您是骑行卡用户，2020年11月5日起通过支付宝支付购买的骑行卡骑行可获能量。2020年11月5日前购买的骑行卡，不参与此次活动。
      .btn(@click="IKnow") 我知道了
</template>

<script>
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { shouldShowWarnModal, getForestAccountStatus } from '@/api/ant-forest';
import Toast from '@/components/toast';
import Dialog from './components/dialog';
import CommonDialog from '../../components/common-modal';
import { closeForest } from '../../api/ant-forest';
import { getTokenAndKey, getTokenAndLocation } from '../../utils/index';
import Condition from './components/condition';

export default {
  components: {
    Dialog,
    CommonDialog,
    Condition,
  },
  data() {
    return {
      dialog: false,
      success: false,
      plain: false,
      account: '-',
      warnDialog: false,
      showNew: false,
      antStatus: null, // 1或3
      preparing: true,
    };
  },
  computed: {
    modeB() {
      return this.success && !this.plain;
    },
  },
  async created() {
    const { account, success, showNew } = this.$route.query;
    if (account !== undefined) {
      this.account = account;
    }
    if (showNew !== undefined) {
      this.showNew = true;
      this.antStatus = 3;
    }
    if (success !== undefined) {
      this.success = success;
      const { token } = await getTokenAndKey();
      shouldShowWarnModal({ token })
        .catch(() => null)
        .then((v) => {
          if (v) {
            this.warnDialog = v.data;
          }
        });
      UBT.pageView({
        pageId: 'platform_popup_reminder',
        categoryId: 'platform',
        businessInfo: {
          adsource: this.$route.query.adsource,
        },
      });
    }
  },
  async mounted() {
    UBT.pageView({
      pageId: 'platform_detai_rules_of_ant_forest',
      categoryId: 'platform',
      businessInfo: {
        adsource: this.$route.query.adsource,
      },
    });
    setTimeout(() => {
      if (this.preparing) {
        this.preparing = false;
      }
    }, 1000);
    if (!this.showNew) {
      const { token, cityCode, adCode } = await getTokenAndLocation();
      getForestAccountStatus({
        token,
        cityCode,
        adCode,
        pointType: 2,
      })
        .then((v) => {
          if (v && v.data) {
            const { antGray, antStatus } = v.data;
            this.antStatus = antStatus;
            if (antGray && antStatus === 3) {
              this.showNew = true;
            }
          }
        })
        .catch(() => null)
        .then(() => {
          this.preparing = false;
        });
    }
  },
  methods: {
    goForest() {
      UBT.clickButton({
        pageId: 'platform_detai_rules_of_ant_forest',
        buttonName: 'platform_link_to_ant_forest',
        categoryId: 'platform',
        businessInfo: {},
      });
      window.location = 'alipays://platformapi/startapp?appId=60000002&source=hellobikeapp';
    },
    goRule() {
      let link = 'https://m.hellobike.com/ebike-h5/latest/article.html?guid=1c64ba9516154fd2ad729e3b3f9dfeaa';
      if (this.antStatus === 3) {
        link = 'http://h.c3x.me/152UtF';
      }
      window.location.href = link;
    },
    IKnow() {
      this.warnDialog = false;
      UBT.clickButton({
        pageId: 'platform_popup_reminder',
        buttonName: 'platform_popup_reminder_OK',
        categoryId: 'platform',
        businessInfo: {
          adsource: this.$route.query.adsource,
        },
      });
      UBT.pageViewOut({
        pageId: 'platform_popup_reminder',
        categoryId: 'platform',
        businessInfo: {
          adsource: this.$route.query.adsource,
        },
      });
    },
    openDialog() {
      this.dialog = true;
      UBT.clickButton({
        pageId: 'platform_detai_rules_of_ant_forest',
        buttonName: 'platform_yes_close',
        categoryId: 'platform',
        businessInfo: {},
      });
      UBT.pageView({
        pageId: 'platform_ant_forest_poppage_close',
        categoryId: 'platform',
        businessInfo: {},
      });
    },
    async close() {
      UBT.clickButton({
        pageId: 'platform_detai_rules_of_ant_forest',
        buttonName: 'platform_close_ant_forest',
        categoryId: 'platform',
        businessInfo: {},
      });
      UBT.clickButton({
        pageId: 'platform_ant_forest_poppage_close',
        buttonName: 'platform_yes_close',
        categoryId: 'platform',
        businessInfo: {},
      });
      const { token } = await getTokenAndKey();
      closeForest({ token, pointType: 2 })
        .then(() => {
          Toast.show('关闭成功');
          this.dialog = false;
          UBT.pageViewOut({
            pageId: 'platform_ant_forest_poppage_close',
            categoryId: 'platform',
            businessInfo: {},
          });
          this.plain = true;
        })
        .catch((e) => {
          Toast.show(e && e.message ? e.message : '关闭失败');
        });
    },
  },
};
</script>

<style lang="less" scoped>
.ant-forest-success {
  display: flex;
  align-items: center;
  flex-direction: column;
  min-height: 100%;
  background-color: #f0f3f5;
  padding-bottom: 0.65rem;

  img {
    pointer-events: none;
  }

  .red {
    color: rgba(36, 39, 41, 1);
    font-weight: 600;
  }

  .banner {
    display: flex;
    margin-bottom: -1.1rem;
    width: 100%;
    height: 2.17rem;
    background: linear-gradient(146deg, #64d283 0%, #00ca9c 100%);
    border-radius: 0 0 0.16rem 0.16rem;

    &.mode-b {
      margin-bottom: -0.57rem;
    }

    .title {
      position: absolute;
      top: 0.36rem;
      transform: translateX(-50%);
      left: 50%;
      font-size: 0.18rem;
      font-weight: 600;
      color: #fff;
      line-height: 0.25rem;
      width: 100%;

      span {
        text-align: center;
      }
    }

    .success-icon {
      width: 0.64rem;
      height: 0.64rem;
      position: absolute;
      top: 0.18rem;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .part-1 {
    width: 3.51rem;
    // background: #fff;
    border-radius: 0.08rem;
    overflow: hidden;
    position: absolute;
    top: 0.86rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .top {
      font-size: 0.24rem;
      font-weight: 600;
      color: #fff;
      line-height: 0.33rem;
      text-align: center;
      margin-bottom: 0.06rem;
    }

    .bottom {
      font-size: 0.12rem;
      color: #fff;
      line-height: 0.17rem;
    }
  }

  .part-2 {
    width: 3.51rem;
    background: #fff;
    border-radius: 0.08rem;
    padding-top: 0.14rem;
    padding-bottom: 0.2rem;
    box-shadow: 0 0.02rem 0.08rem 0 rgba(0, 0, 0, 0.04);

    .title {
      font-size: 0.16rem;
      font-weight: 600;
      color: #242729;
      text-align: center;
      margin-bottom: 0.07rem;
    }

    .conditions {
      display: flex;
      justify-content: space-between;
      padding-left: 0.23rem;
      padding-right: 0.34rem;
      margin-top: 0.24rem;

      .condition-item {
        flex-direction: column;

        &:nth-of-type(2) {
          position: relative;
          left: -0.1rem;
        }

        .condition-icon {
          width: 0.4rem;
          height: 0.4rem;
          margin-bottom: 0.08rem;
        }

        .condition-content {
          font-size: 0.12rem;
          line-height: 0.17rem;
          font-weight: 500;
          color: #5a6066;
        }
      }
    }
  }

  .part-3 {
    width: 3.51rem;
    background: #fff;
    border-radius: 0.08rem;
    margin-top: 0.08rem;
    padding-top: 0.14rem;
    padding-bottom: 0.2rem;
    padding-left: 0.24rem;
    padding-right: 0.19rem;
    box-shadow: 0 0.02rem 0.08rem 0 rgba(0, 0, 0, 0.04);

    .title {
      font-size: 0.16rem;
      font-weight: 600;
      color: #242729;
      text-align: center;
      margin-bottom: 0.24rem;
    }

    .rule {
      &:not(:last-of-type) {
        margin-bottom: 0.3rem;
      }
    }

    .rule-title {
      font-weight: 600;
      color: rgba(36, 39, 41, 1);
      font-size: 0.14rem;
      margin-bottom: 0.04rem;
    }

    .rule-content {
      color: rgba(36, 39, 41, 1);
      font-size: 0.14rem;
    }

    .gray {
      font-size: 0.12rem;
      color: rgba(135, 144, 153, 1);
    }
  }

  .close {
    font-size: 0.14rem;
    color: #242729;
    text-align: center;
    margin-top: 0.16rem;

    .close-icon {
      width: 0.14rem;
      height: 0.14rem;
      margin-right: 0.05rem;
    }

    span.text {
      position: relative;
      line-height: 0.14rem;
    }
  }

  .hint {
    padding: 0 0.12rem;
    margin-top: 0.16rem;
    display: flex;
    flex-direction: column;
    height: 0.68rem;
    font-size: 0.12rem;
    color: #5a6066;
    line-height: 0.19rem;

    .go {
      color: rgba(0, 129, 241, 1);
    }
  }

  .warn-dialog {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: white;
    width: 3.2rem;
    border-radius: 0.12rem;
    padding: 0.37rem 0.16rem 0.21rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .warn-logo {
      width: 1.69rem;
      height: 1.02rem;
    }

    .title {
      font-size: 0.16rem;
      font-weight: 600;
      color: #242729;
      line-height: 0.22rem;
      margin-top: 0.05rem;
      margin-bottom: 0.08rem;
      white-space: nowrap;
    }

    .content {
      font-size: 0.14rem;
      color: #5a6066;
      line-height: 0.2rem;
      margin-bottom: 0.18rem;
      text-align: center;
    }

    .btn {
      text-align: center;
      height: 0.48rem;
      background: #08f;
      border-radius: 0.08rem;
      width: 100%;
      font-size: 0.18rem;
      font-weight: 500;
      color: #fff;
      line-height: 0.48rem;
    }
  }
}
</style>
